import formatTimingPrefix from "./formatTimingPrefix";
import getLoginAppStartTime from "./getLoginAppStartTime";
import setDataDogUserProperty from "../dataDog";

const LOGIN_APP_START = "loginAppStart";

const sentryLoginAppStartMetrics = () => {
    const timingPrefix = formatTimingPrefix();

    const loginAppStartExists = getLoginAppStartTime();

    const eventName = `${timingPrefix}${LOGIN_APP_START}`;

    if (loginAppStartExists) {
        // Remove old and set with new value
        sessionStorage.removeItem(eventName);
    }

    const loginAppStartTime = new Date().getTime();
    const timeZero = sessionStorage.getItem(`${timingPrefix}timeZero`);
    const loginAppStartDelta = String(loginAppStartTime - Number(timeZero));

    const { hash } = window.location;

    const eventPayload = JSON.stringify({
        timestamp: loginAppStartTime,
        hash
    });

    sessionStorage.setItem(eventName, eventPayload);
    sessionStorage.setItem(eventName + "Delta", String(loginAppStartDelta));

    // set the data dog user context for authenticationType
    setDataDogUserProperty("SSO");
};

export default sentryLoginAppStartMetrics;
